import { defineMessages } from 'react-intl';

export default defineMessages({
  summaryHeading: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.summary-heading',
    defaultMessage: 'Guaranteed minimum payout per qualifying reservation',
  },
  summaryBodyParagraph1: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.summary-body',
    defaultMessage:
      'This generates truly incremental revenue by turning unused spots into earnings, rather than letting them go to waste.',
  },
});
